import { FacilitiesCarousel } from "./FacilitiesCarousel";
import { FacilitiesFilters } from "./FacilitiesFilters";
import { FacilitiesList } from "./FacilitiesList";
import { FacilitiesMap } from "./FacilitiesMap";

type FacilitiesCompound = {
  Filters: typeof FacilitiesFilters;
  List: typeof FacilitiesList;
  Carousel: typeof FacilitiesCarousel;
  Map: typeof FacilitiesMap;
};

/** The facilities tab's parts. Each renders nothing on other tabs. */
export const Facilities: FacilitiesCompound = {
  Filters: FacilitiesFilters,
  List: FacilitiesList,
  Carousel: FacilitiesCarousel,
  Map: FacilitiesMap,
};
